export default __webpack_public_path__ + "static/media/54E6F359-F8EC-4AD8-9741-1634D9435D7E_1_105_c.30586bce.jpeg";